<div class="legend-bullet" *ngFor="let item of legendBullets">
	<span class="color" [style.background]="item.color" [style.border-color]="item.border" [class.has-border]="!!item.border"></span>
	<span class="text">{{ item.text }}</span>
</div>